"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var _generatedIcons_1 = require("./_generatedIcons");

var Sizes;

(function (Sizes) {
  Sizes["SMALL"] = "lsg--icon__small";
  Sizes["MEDIUM"] = "lsg--icon__medium";
  Sizes["SM_MEDIUM"] = "lsg--icon__sm-medium";
  Sizes["LARGE"] = "lsg--icon__large";
  Sizes["CIRCLE"] = "lsg--icon__circle";
  Sizes["CIRCLE2"] = "lsg--icon__circle2";
})(Sizes = exports.Sizes || (exports.Sizes = {}));

var sizesNumeric = {
  "lsg--icon__small": {
    xs: 24
  },
  "lsg--icon__medium": {
    xs: 48
  },
  "lsg--icon__large": {
    xs: 96
  },
  "lsg--icon__circle": {
    xs: 24
  },
  "lsg--icon__circle2": {
    xs: 24,
    sm: 48
  }
};
var Colors;

(function (Colors) {
  Colors["DEFAULT"] = "lsg--icon__default";
  Colors["PRIMARY"] = "lsg--icon__primary";
  Colors["SECONDARY"] = "lsg--icon__secondary";
  Colors["ERROR"] = "lsg--icon__error";
  Colors["SUCCESS"] = "lsg--icon__success";
  Colors["NOTE"] = "lsg--icon__note";
  Colors["DISABLED"] = "lsg--icon__disabled";
  Colors["BLACK"] = "lsg--icon__black";
  Colors["WHITE"] = "lsg--icon__white";
  Colors["ANTHRACITE"] = "lsg--icon__anthracite";
})(Colors = exports.Colors || (exports.Colors = {}));

var circle2Icon = {
  "lsg--icon__primary": "lsg--icon__black"
};
var circle2Fill = {
  "lsg--icon__primary": "lsg--icon__fill-primary"
};
var Variants;

(function (Variants) {
  Variants["OUTLINE"] = "outline";
  Variants["SOLID"] = "solid";
})(Variants = exports.Variants || (exports.Variants = {}));

var Icon =
/** @class */
function (_super) {
  __extends(Icon, _super);

  function Icon() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.uuid = uniqid_1["default"]("icon-");
    _this.state = {
      sizeNumeric: Icon.getSize(_this.props.size, utils_1.WindowEvents.getViewportSize())
    };

    _this.updateSize = function (viewport) {
      var sizeNumeric = Icon.getSize(_this.props.size, viewport);

      if (sizeNumeric !== _this.state.sizeNumeric) {
        _this.setState({
          sizeNumeric: sizeNumeric
        });
      }
    };

    return _this;
  }

  Icon.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.updateSize);
  };

  Icon.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.updateSize);
  };

  Icon.prototype.render = function () {
    var _a = this.props,
        colorProp = _a.color,
        className = _a.className,
        name = _a.name,
        variant = _a.variant,
        size = _a.size,
        titleProp = _a.title,
        svgAttrs = _a.svgAttrs,
        id = _a.id;
    var sizeNumeric = this.state.sizeNumeric;
    var uuid = id || this.uuid;
    var ariaAttrs = svgAttrs.role === "img" ? {
      "aria-labelledby": uuid + "-title"
    } : {};
    var title = titleProp === undefined ? utils_1.Localization.getIconTitle(name) : titleProp;
    var color = colorProp;
    var backgroundColor;

    if (size === Sizes.CIRCLE2 && circle2Icon[colorProp]) {
      color = circle2Icon[colorProp];
      backgroundColor = circle2Fill[colorProp];
    }

    if (!name) {
      return React.createElement("span", null);
    }

    var icon = _generatedIcons_1.svgIcon(uuid, name, __assign(__assign(__assign({
      /* Icons shall be not focusable in ie by default, if required it can be set manually through svgAttrs or whatever */
      focusable: "false"
    }, svgAttrs), ariaAttrs), {
      className: CSSPrefix_1.lsgPre + "icon-svg"
    }), title, variant, sizeNumeric);

    if (!icon) {
      // tslint:disable no-console
      console.warn("Icon '" + name + "' not found."); // tslint:enable
    }

    return React.createElement("span", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "icon", className, CSSPrefix_1.prefixEnumClassNames(size), CSSPrefix_1.prefixEnumClassNames(color), CSSPrefix_1.prefixEnumClassNames(backgroundColor)])
    }, icon || _generatedIcons_1.svgIcon(uuid, Icon.Names.symbols___error, {
      focusable: "false",
      className: CSSPrefix_1.lsgPre + "icon-svg"
    }));
  };

  Icon.Colors = Colors;
  Icon.Sizes = Sizes;
  Icon.Variants = Variants;
  Icon.Names = _generatedIcons_1.iconNames;
  Icon.defaultProps = {
    color: Colors.DEFAULT,
    size: Sizes.SMALL,
    variant: Variants.OUTLINE,
    svgAttrs: {
      role: "img"
    }
  };

  Icon.getSize = function (sizeProp, viewport) {
    return utils_1.ViewportUtils.getMobileFirstValue(sizesNumeric[sizeProp], viewport);
  };

  Icon.getDerivedStateFromProps = function (nextProps) {
    return {
      sizeNumeric: Icon.getSize(nextProps.size, utils_1.WindowEvents.getViewportSize())
    };
  };

  return Icon;
}(React.Component);

exports.Icon = Icon;